import { render, staticRenderFns } from "./CreateRequisition.vue?vue&type=template&id=32a2f4b0"
import script from "./CreateRequisition.vue?vue&type=script&lang=js"
export * from "./CreateRequisition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports